<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-wifi title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.machines' | transloco}}</p>
            <p>
              {{(mode == 'create' ? 'misc.creation.machine' : 'misc.edition.machine') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <form *ngIf="!isMachineLoading && machineForm" [formGroup]="machineForm">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="serial">{{'attribute.serialNumber' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="serial" id="serial" (keyup)="changeSerialNumber()" pInputText type="text">
            </div>
            <app-validation-errors [control]="machineForm.get('serial')"></app-validation-errors>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="alias">{{'attribute.alias' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="alias" id="alias" pInputText type="text">
            </div>
            <app-validation-errors [control]="machineForm.get('alias')"></app-validation-errors>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="description">{{'attribute.description' | transloco}}:</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="description" id="description" pInputText type="text">
            </div>
            <app-validation-errors [control]="machineForm.get('description')"></app-validation-errors>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="model">{{'attribute.model' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-dropdown [placeholder]="'select.model' | transloco" [filter]="true" filterBy="modelName"
                styleClass="w-full" [options]="models" (onChange)="selectedModel=$event.value" id="model"
                optionLabel="modelName" formControlName="model" [showClear]="true">
                <ng-template let-model pTemplate="item">
                  <div class="flex align-items-center">
                    <div style="width:30px;">
                      <img [src]="model.image" [alt]="model.modelName" style="max-height: 30px;max-width: 100%;" />
                    </div>
                    <p class="mb-0 ml-1 p-0">{{model.modelName}}</p>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <app-validation-errors [control]="machineForm.get('model')"></app-validation-errors>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="organization">{{'model.organization' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-treeSelect [(ngModel)]="organization" [placeholder]="'select.organization' | transloco"
                [options]="hierarchy" [ngModelOptions]="{standalone: true}" id="organization"
                [disabled]="editMachineFromGroup"></p-treeSelect>
            </div>
          </div>
          <div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')" class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="group">{{'attribute.groups' | transloco}}: </label>
            </div>
            <div class="col-12">
              <p-multiSelect [(ngModel)]="selectedGroups" [placeholder]="'select.group' | transloco" [filter]="true"
                filterBy="label" display="chip" styleClass="w-full" appendTo="body" [options]="groups" id="group"
                optionLabel="label" [ngModelOptions]="{standalone: true}"></p-multiSelect>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="simNumber">{{'attribute.simNumber' | transloco}}:</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="simNumber" id="simNumber" pInputText type="text">
            </div>
            <app-validation-errors [control]="machineForm.get('simNumber')"></app-validation-errors>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="automaticGeoloc">{{'attribute.automaticGeoloc' | transloco}}:</label>
            </div>
            <div class="col-12">
              <p-checkbox id="automaticGeoloc" formControlName="automaticGeoloc" binary="true" class="w-full"></p-checkbox>
            </div>
          </div>
        </div>

        <div *ngIf="selectedModel" class="flex col-12 mt-2 mb-2 align-items-center justify-content-center">
          <img [src]="selectedModel.image" [alt]="selectedModel.modelName"
            style="max-width: 100%; max-height: 300px;" />
        </div>

        <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.subscriptionStatus' | transloco}}:</label>
            </div>
            <div class="col-12">
              <div class="mb-1">
                <p-radioButton formControlName="active" [label]="'attribute.statusInactive' | transloco" name="active"
                               [value]="false" (onClick)="setStatusInactive()"></p-radioButton>
              </div>
              <div class="p-field-radiobutton margin-top">
                <p-radioButton formControlName="active" [label]="'attribute.statusActive' | transloco" name="active"
                               [value]="true" (onClick)="setStatusActive()"></p-radioButton>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="startDate">{{'attribute.subscriptionStartDate' | transloco}}:
                <span *ngIf="isActiveSubscription()">&nbsp;(*)</span>
              </label>
            </div>
            <div class="col-12">
              <p-calendar formControlName="startDate" [firstDayOfWeek]="1" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" [yearRange]="availableYearRange" [minDate]="endLastSubscription"
                (onClearClick)="clearDate('endDate')" (onSelect)="changeDateState('endDate')" dateFormat="dd/mm/yy"
                appendTo="body" styleClass="w-full" id="startDate" inputId="startDate"></p-calendar>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="endDate">{{'attribute.subscriptionEndDate' | transloco}}:
                <span *ngIf="isActiveSubscription()">&nbsp;(*)</span>
              </label>
            </div>
            <div class="col-12">
              <p-calendar formControlName="endDate" [firstDayOfWeek]="1" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" [yearRange]="availableYearRange" [minDate]="startDate"
                dateFormat="dd/mm/yy" appendTo="body" styleClass="w-full" id="endDate" inputId="endDate"></p-calendar>
            </div>
          </div>
        </div>
        <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="latitude">{{'attribute.latitude' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="latitude" id="latitude" pInputText type="number"
                (ngModelChange)="onLocationInputChange()">
            </div>
            <app-validation-errors [control]="machineForm.get('latitude')"></app-validation-errors>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="longitude">{{'attribute.longitude' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="longitude" id="longitude" pInputText type="number"
                (ngModelChange)="onLocationInputChange()">
            </div>
            <app-validation-errors [control]="machineForm.get('longitude')"></app-validation-errors>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12 flex justify-content-between">
              <label for="eui">{{'attribute.eui' | transloco}}: (*)</label>
              <span class="flex flex-column align-content-end font-italic">{{'common.uppercaseValue' | transloco}}</span>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="eui" id="eui" (paste)="handlePasteEui($event)" (keyup)="handleChangeEui()" pInputText type="text">
            </div>
            <app-validation-errors [control]="machineForm.get('eui')"></app-validation-errors>
          </div>
        </div>
        <div class="grid" style="margin-top: 0.15rem">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="locality">{{'attribute.locality' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="locality" id="locality" pInputText type="text">
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="state" id="state" pInputText type="text">
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="country">{{'attribute.country' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <input class="w-full" formControlName="country" id="country" pInputText type="text">
            </div>
          </div>
        </div>
      </form>

      <div *ngIf="isMachineLoading || machineForm == null">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="serial">{{'attribute.serialNumber' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="alias">{{'attribute.alias' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="description">{{'attribute.description' | transloco}}:</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="model">{{'attribute.model' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="organization">{{'model.organization' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')" class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="group">{{'attribute.groups' | transloco}}: </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="simNumber">{{'attribute.simNumber' | transloco}}:</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="automaticGeoloc">{{'attribute.automaticGeoloc' | transloco}}:</label>
            </div>
            <div class="col-12">
              <p-skeleton width="1.5rem" height="1.5rem"></p-skeleton>
            </div>
          </div>
        </div>

        <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label>{{'attribute.subscriptionStatus' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="startDate">{{'attribute.startDate' | transloco}}:
              </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="endDate">{{'attribute.endDate' | transloco}}:
              </label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
        </div>
        <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="latitude">{{'attribute.latitude' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="longitude">{{'attribute.longitude' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="eui">{{'attribute.eui' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="locality">{{'attribute.locality' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-4">
            <div class="form-field col-12">
              <label for="country">{{'attribute.country' | transloco}}: (*)</label>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>

      <div class="grid mt-2">
        <div class="col-12">
          <div class="col-12">
            <p-skeleton *ngIf="isMachineLoading" width="100%" height="30rem"></p-skeleton>
            <div class="rounded" id="map"></div>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="!isMachineLoading && machineForm">
        <div class="col-12">
          <div class="mt-auto col-12">
            <div class="flex justify-content-between mt-4">
              <button [label]="'common.cancel' | transloco" [routerLink]="'/machines'" pButton class="p-button-danger"
                iconPos="right"></button>
              <p-button [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
                [disabled]="!isValid()" [loading]="persistingChanges" (onClick)="persistMachineData()"
                styleClass="p-button-primary"></p-button>
            </div>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="isMachineLoading || machineForm == null">
        <div class="col-12">
          <div class="mt-auto col-12">
            <div class="flex justify-content-between mt-4">
              <div class="w-7rem">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
              <div class="w-7rem">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
